
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"32","cy":"32","r":"32","fill":"#CE0C0C"}}),_c('path',{attrs:{"d":"M44.6 20.42c-.78-.78-2.04-.78-2.82 0L32 30.18l-9.78-9.78c-.78-.78-2.04-.78-2.82 0-.78.78-.78 2.04 0 2.82L29.18 33l-9.78 9.78c-.78.78-.78 2.04 0 2.82.78.78 2.04.78 2.82 0L32 35.82l9.78 9.78c.78.78 2.04.78 2.82 0 .78-.78.78-2.04 0-2.82L34.82 33l9.78-9.78c.76-.76.76-2.04 0-2.8z","fill":"#fff"}})])
          )
        }
      }
    